export const initialSelectionState = {
  selectedItems: [],
  deselectedItems: [],
  allItemsSelected: false,
  allowSelectAll: true,
};

export default (state, action) => {
  switch (action.type) {
    case 'SELECTION_INITIALIZE':
      return { ...state, ...action.state };
    case 'SELECTION_SET_SELECTED_ITEMS':
      return { ...state, selectedItems: action.selectedItems || [] };
    case 'SELECTION_SET_DESELECTED_ITEMS':
      return { ...state, deselectedItems: action.deselectedItems || [] };
    case 'SELECTION_SET_ALL_ITEMS_SELECTED':
      return {
        ...state,
        allItemsSelected: action.allItemsSelected,
        deselectedItems: [],
        selectedItems: [],
      };
    case 'SELECTION_CLEAR_SELECTION':
      return {
        ...state,
        selectedItems: [],
        deselectedItems: [],
        allItemsSelected: false,
      };
    case 'SELECTION_SET_ALLOW_SELECT_ALL':
      return { ...state, allowSelectAll: action.allowSelectAll ?? true };
    default:
      return { ...state };
  }
};
